import type { HTMLAttributes } from "react";

type AlertProps = HTMLAttributes<HTMLDivElement> & { variant?: "default" | "destructive" | "warning" | "success" };

/** shadcn/ui 风格提示容器。 */
export function Alert({ className = "", variant = "default", ...props }: AlertProps) {
  return <div role="alert" data-slot="alert" data-variant={variant} className={`fm-shadcn-alert ${className}`.trim()} {...props} />;
}

/** 提示标题。 */
export function AlertTitle({ className = "", ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return <h5 data-slot="alert-title" className={`fm-shadcn-alert-title ${className}`.trim()} {...props} />;
}

/** 提示正文。 */
export function AlertDescription({ className = "", ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div data-slot="alert-description" className={`fm-shadcn-alert-description ${className}`.trim()} {...props} />;
}
